<template>
  <v-row class="mt-5 ml-5 mr-5">
    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          style="text-align: left !important"
        >
          <span class="text-capitalize">{{
            categories[categoriesValues]
          }}</span>
          <v-icon> mdi-chevron-down </v-icon>
        </v-btn>
      </template>
      <v-list dark>
        <v-list-item-group
          mandatory
          v-model="categoriesValues"
          @change="updateCategories"
        >
          <template v-for="(item, index) in categories">
            <v-list-item :key="index">
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item>
            <v-divider :key="index + '_divider'"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <v-menu offset-y open-on-hover close-on-content-click max-height="200">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          style="text-align: left !important"
          class="mt-3"
        >
          <span class="text-capitalize"
            >{{ specialists[specialistsValues] }}
          </span>
          <v-icon> mdi-chevron-down </v-icon>
        </v-btn>
      </template>
      <v-list dark>
        <v-list-item-group
          mandatory
          v-model="specialistsValues"
          @change="updateSpecialists"
        >
          <template v-for="(item, index) in specialists">
            <v-list-item :key="index">
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item>
            <v-divider :key="index + '_divider'"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <v-text-field
      class="mt-3"
      color="#a81e2d"
      dark
      prepend-inner-icon="mdi-magnify"
      clearable
      height="50"
      label="Search"
      solo
      dense
      @input="updateSearchQuery"
    ></v-text-field>
  </v-row>
</template>
<style scoped lang="scss">
au-1 {
  max-width: "10px" !important;
}
.v-btn {
  padding-right: 3px !important;
  display: flex !important;
  justify-content: flex-start !important;
  width: 100% !important;
  i {
    margin-left: auto !important;
  }
  &:hover {
    i {
      color: $pred;
    }
  }
}
</style>
<script>
import { mapActions } from "vuex";
export default {
  mounted() {
    // fill filters lists and concat intial values
    this.$store.state.TeamMembers.filter((item) => {
      this.specialists = [
        ...new Set(this.specialists.concat(item.specialists)),
      ];
      this.categories = [...new Set(this.categories.concat(item.categories))];
    });

    //filter null and empty values
    this.specialists = this.specialists.filter(function (el) {
      return el != null && el != "";
    });
    this.categories = this.categories.filter(function (el) {
      return el != null && el != "";
    });
    //console.log(this.categories)

    //set previous selected values
    if (this.$store.state.Specfilters.length > 0)
      this.specialistsValues = this.specialists.indexOf(
        this.$store.state.Specfilters
      );

    if (this.$store.state.Teamfilters.length > 0)
      this.categoriesValues = this.categories.indexOf(
        this.$store.state.Teamfilters
      );
    console.log(this.categoriesValues);
    console.log(this.specialistsValues);
  },
  data() {
    return {
      specialists: ["All Specialists"],
      categories: ["All Teams"],
      specialistsValues: 0,
      categoriesValues: 0,
    };
  },
  methods: {
    ...mapActions([
      "UpdateSearchQueryAction",
      "UpdateTeamfiltersAction",
      "UpdateSpecfiltersAction",
    ]),
    updateSearchQuery(input) {
      this.UpdateSearchQueryAction({ value: input });
      console.log(this.$store.state.SearchQuery);
    },
    updateSpecialists() {
      // if (this.specialistsValues.length == 0)
      //   this.specialistsValues.push("all specialists");

      // if (
      //   this.specialistsValues.length > 1 &&
      //   this.specialistsValues.indexOf("all specialists") > -1
      // ) {
      //   this.specialistsValues.splice(
      //     this.specialistsValues.indexOf("all specialists"),
      //     1
      //   );
      // }
      this.UpdateSpecfiltersAction({
        value: this.specialists[this.specialistsValues],
      });
    },
    updateCategories() {
      //console.log(this.categoriesValues);
      // if (this.categoriesValues.length == 0)
      //   this.categoriesValues.push("all teams");
      // if (
      //   this.categoriesValues.length > 1 &&
      //   this.categoriesValues.indexOf("all teams") > -1
      // ) {
      //   this.categoriesValues.splice(
      //     this.categoriesValues.indexOf("all teams"),
      //     1
      //   );
      // }
      this.UpdateTeamfiltersAction({
        value: this.categories[this.categoriesValues],
      });
    },
  },
};
</script>